import { render, staticRenderFns } from "./DonationPage.vue?vue&type=template&id=b5027b5e&scoped=true&"
import script from "./DonationPage.vue?vue&type=script&lang=js&"
export * from "./DonationPage.vue?vue&type=script&lang=js&"
import style0 from "./DonationPage.vue?vue&type=style&index=0&id=b5027b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5027b5e",
  null
  
)

export default component.exports